import React from 'react'
import { TaskBadgeCountProvider } from '../../pages/tasks/hooks/useTaskBadgeCount.jsx'
import { ChecklistIcon } from '../../ui'

const BRAND_GREEN = '#3B6D11'

/**
 * Nav tab for the Tasks page. Renders as one item inside the sidebar's
 * bottom labelled tab bar: a vertically stacked icon + label, with an
 * optional badge for the open-task count. Mounts its own
 * TaskBadgeCountProvider so the count stays accurate without a global cache.
 */
export function TasksNavEntry({
  tasksOpen = false,
  onOpenTasks,
  me,
}) {
  return (
    <TaskBadgeCountProvider me={me} enabled={!!me?.userId}>
      {({ openCount }) => {
        const badgeText = openCount > 9 ? '9+' : String(openCount)
        const ariaLabel =
          openCount > 0 ? `Tasks, ${openCount} open` : 'Tasks'
        const activeColor = tasksOpen ? BRAND_GREEN : 'var(--text-secondary)'
        return (
          <button
            type="button"
            className="nav-tab"
            onClick={onOpenTasks}
            aria-label={ariaLabel}
            aria-current={tasksOpen ? 'page' : undefined}
            style={{
              color: activeColor,
              fontWeight: tasksOpen ? 500 : 400,
            }}
          >
            <span style={styles.iconWrap} aria-hidden="true">
              <ChecklistIcon />
              {openCount > 0 && (
                <span style={styles.badge} data-testid="tasks-nav-badge">
                  {badgeText}
                </span>
              )}
            </span>
            <span style={styles.label}>Tasks</span>
          </button>
        )
      }}
    </TaskBadgeCountProvider>
  )
}

const styles = {
  iconWrap: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
  },
  label: {
    fontSize: 10,
    lineHeight: 1.2,
  },
  badge: {
    position: 'absolute',
    top: -4,
    right: -7,
    minWidth: 12,
    height: 12,
    padding: '0 3px',
    borderRadius: 7,
    background: '#c45a5a',
    color: '#fff',
    fontSize: 8,
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
}
